import { Formik } from 'formik';
import { GraphQLError } from 'graphql';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import {
	type TotpMfaChallenge,
	type UpdateSessionResponse,
	useTotpMfaChallengeMutation,
} from '@treams/treams-network';
import {
	Button,
	FlexGap,
	GraphQLErrorMessage,
	OtpInput,
	Paragraph,
	Subheading,
	tokens,
} from '@treams/treams-ui';

import PublicForm from '../../../components/authentication/PublicForm';

export default function TotpMfaChallenge(props: {
	context: string;
	challenge: TotpMfaChallenge;
	onResponse: (response: UpdateSessionResponse) => void;
	onCancel: () => void;
}) {
	const { t } = useTranslation();

	const { context, challenge, onCancel } = props;

	const [commit] = useTotpMfaChallengeMutation();
	const [error, setError] = useState<GraphQLError | undefined>(undefined);

	return (
		<Formik
			initialValues={{
				totp: '',
			}}
			onSubmit={async ({ totp }, { resetForm }) => {
				try {
					const { data } = await commit({
						variables: {
							input: {
								response: {
									context,
									totpMfa: {
										username: challenge.username,
										totp,
									},
								},
							},
						},
					});

					props.onResponse(data!.updateSession);
				} catch (errors) {
					resetForm();
					setError(errors.graphQLErrors[0]);
				}
			}}
		>
			{({ values }) => (
				<PublicForm>
					<Subheading mb={`${tokens.gap.group}px`}>{t('auth.login.mfa.title')}</Subheading>
					<Paragraph mb={`${tokens.gap.section}px`}>{t('auth.login.mfa.totp.heading')}</Paragraph>
					<Box mb={`${tokens.gap.section}px`}>
						<OtpInput.Formik length={6} name="totp" autoFocus />
					</Box>
					<GraphQLErrorMessage error={error} />
					<FlexGap gap={8} mt={3} alignItems="center">
						<Button.Formik
							type="primary"
							flex={1}
							title={t('personalSettings.mfa.totp.secretKeyVerification.verify')}
							disableSuccess={Boolean(error)}
							disabled={values.totp.length !== 6}
						/>
						<Button type="secondary" onClick={onCancel} title={t('common.cancel')} flex={1} />
					</FlexGap>
				</PublicForm>
			)}
		</Formik>
	);
}
